import nameModelValidator from 'forms/shared/validators/models/name/name';
import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { isPVQForm } from 'helpers/form';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { foreignContactRelationshipOptions } from 'constants/enums/foreignActivityOptions';
import { hasYesOrNo } from 'models/validate';
import { ForeignActivitiesSupportItemModel } from '../types';

export const foreignActivitiesSupportItemValidator: ValidateJSModel<ForeignActivitiesSupportItemModel> = {
  // used in pvq & sf same validation
  Name: (value, attributes, attributeName, options) => ({
    presence: true,
    model: { validator: nameModelValidator },
  }),

  Address: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes?.AddressNotApplicable?.applicable === false) {
        return {};
      }
      return {
        presence: true,
        location: { validator: pvqLocationModelValidator },
      };
    }
    return {
      presence: true,
      location: { validator: locationAddressModelValidator },
    };
  },

  Relationship: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes?.RelationshipType?.value === 'Other') {
        return { hasValue: true };
      }

      return {};
    }
    return { hasValue: true };
  },
  // used in pvq & sf
  Amount: (value, attributes, attributeName, options) => ({ presence: true, model: { validator: currencyModelValidator } }),
  // used in pvq & sf
  Frequency: (value, attributes, attributeName, options) => ({ hasValue: true }),

  Citizenship: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: true, country: { excludeUnitedStates: true } };
    }
    return { hasValue: true, country: true };
  },

  AmountEstimated: {},
  // pvq only
  RelationshipType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: foreignContactRelationshipOptions,
            },
          },
        },
      };
    }
    return {};
  },
  // pvq only
  ReasonForSupport: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: true };
    }
    return { };
  },
  // pvq only
  PlansForFutureSupport: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  // pvq only
  PlansForFutureSupportExplain: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: true };
    }
    return { };
  },
};
